import { Modal, } from 'reactstrap';
import { FaTimes } from 'react-icons/fa';
import { useState } from 'react';
import { baseUrl } from '../../../shared/baseUrl';
import { createNotification } from '../../Common/CreateNotification';
import { TOKEN_KEY } from '../../../Utils/Constants';
import { checkAuth } from '../../../Utils/CheckAuthentication';
import { useSelector, useDispatch } from 'react-redux';
import { toggleVerify } from '../../../Redux/reducers/verifySlice';
import { changeUser } from '../../../Redux/reducers/userSlice';
import { toggleLoading } from '../../../Redux/reducers/loadingSlice';

const Verify = () => {
    const verify = useSelector(state => state.verify.verify);
    const dispatch = useDispatch();

    const [verificationCode, setVerificationCode] = useState('');


    const verifyUser = (e) => {
        e.preventDefault();
        dispatch(toggleLoading(true));
        var formData = new FormData();
        formData.append('verification_code', verificationCode);
        fetch(baseUrl + 'verify-user', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem(TOKEN_KEY)).token
            },
            body: formData
        })
            .then(res => checkAuth(res))
            .then(res => {
                if (res.success) {
                    var verifiedUser = JSON.parse(localStorage.getItem(TOKEN_KEY));
                    verifiedUser.is_verified = true;
                    localStorage.setItem(TOKEN_KEY, JSON.stringify(verifiedUser));
                    createNotification('success', "Successfully Verified");
                    dispatch(toggleLoading(false));
                    dispatch(toggleVerify(false));
                    dispatch(changeUser(verifiedUser));
                }
                else {
                    createNotification('error', "Verification Failed");
                    dispatch(toggleLoading(false));
                }
            })
            .catch(err => {
                createNotification('error', "Verification Error");
                dispatch(toggleLoading(false));
            });
    }

    const resendCode = () => {
        dispatch(toggleLoading(true));
        fetch(baseUrl + 'send-verification-email', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem(TOKEN_KEY)).token
            }
        })
            .then(res => checkAuth(res))
            .then(res => {
                if (res.success) {
                    createNotification('success', "Verification Code Sent");
                    dispatch(toggleLoading(false));
                }
                else {
                    createNotification('error', res.message);
                    dispatch(toggleLoading(false));
                }
            })
            .catch(err => {
                createNotification('error', "Error sending Code");
                dispatch(toggleLoading(false));
            });
    }


    return (
        <>
            <Modal isOpen={verify} className='position-relative' centered>
                <div onClick={() => { dispatch(toggleVerify(false)) }} className='position-absolute cursor-pointer' style={{ top: 6, right: 10 }}>
                    <FaTimes size={20} />
                </div>
                <div className='px-3 py-3'>
                    <form onSubmit={verifyUser}>
                        <h3>Verification Code:</h3>
                        <p className='small'>Plese enter verification code sent to your email address</p>
                        <input required placeholder='Verification Code' className='form-control' value={verificationCode} onChange={(e) => { setVerificationCode(e.target.value) }} />
                        <div className="col-12 d-flex justify-content-start my-3">
                            <button type="submit" className="btn btn-primary">Submit</button>
                        </div>
                    </form>
                    <hr className='mb-3' style={{ color: "#a8a8a890" }} />
                    <p className='small'>Didn't get the code? <span onClick={() => { resendCode(); }} className='cursor-pointer text-primary'>Resend</span></p>

                </div>
            </Modal>
        </>
    );
}

export default Verify;